import { render, staticRenderFns } from "./LProjectSessionEdition.vue?vue&type=template&id=4c4aca5f&scoped=true&"
import script from "./LProjectSessionEdition.vue?vue&type=script&lang=js&"
export * from "./LProjectSessionEdition.vue?vue&type=script&lang=js&"
import style0 from "./LProjectSessionEdition.vue?vue&type=style&index=0&id=4c4aca5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4aca5f",
  null
  
)

export default component.exports